var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.077,
    height: 13.714,
    viewBox: "360 337.818 14.077 13.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2273"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2272",
    transform: "translate(360 337.818)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.966 8.479h-.444v-.444a.4.4 0 1 0-.801 0v.444h-.444a.4.4 0 1 0 0 .801h.444v.444a.4.4 0 1 0 .801 0V9.28h.444a.4.4 0 0 0 0-.801",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06 5.885h-.444v-.444a.4.4 0 1 0-.801 0v.444h-.444a.4.4 0 1 0 0 .801h.444v.444a.4.4 0 1 0 .801 0v-.444h.444a.4.4 0 0 0 0-.801",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.716 6.135h-.444v-.444a.4.4 0 1 0-.801 0v.444h-.444a.4.4 0 1 0 0 .801h.444v.444a.4.4 0 1 0 .801 0v-.444h.444a.4.4 0 0 0 0-.801",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.497 2.197h-.444v-.444a.4.4 0 1 0-.801 0v.444h-.444a.4.4 0 1 0 0 .801h.444v.444a.4.4 0 1 0 .801 0v-.444h.444a.4.4 0 0 0 0-.801",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.444 13.714H2.633A2.636 2.636 0 0 1 0 11.081V.633a.632.632 0 1 1 1.266 0v10.448c0 .753.614 1.366 1.367 1.366h10.811a.633.633 0 0 1 0 1.267",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6872"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.078v13.714H0V0z",
    "data-name": "Rectangle 1587"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.88c2f501a0d25f66b2fd4eaab8b35c53.svg";
export { ForwardRef as ReactComponent };